import * as types from 'store/actions/types';
import produce from 'immer';

export const INITIAL_STATE = {
	loading: true,
	error: false,
	data: {
		task: {},
		assets: []
	}
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			// ****************** CLEAR DATA ******************
			case types.CLEAR_STATE:
				return { ...INITIAL_STATE };

			// ****************** FETCH VOD ENCODING ******************
			case types.FETCH_VOD_ENCODING_LOADING:
				draft.loading = true;
				draft.error = false;
				return;

			case types.FETCH_VOD_ENCODING_SUCCESS:
				draft.loading = false;
				draft.data = action.payload;
				return;

			case types.FETCH_VOD_ENCODING_ERROR:
				draft.error = action.payload;
				return;

			default:
				return state;
		}
	});
